import React, { useEffect, useState } from "react";
import FilesView from "../../../../Components/Utils/FilesView";

function ViewEquipmentEqu({ item, data, open, onCancel }) {
  const displayItem = data;

  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length > 0 ? data?.attachments : []);
    }
  }, [data]);

  return (
    <div className="w-full flex flex-col gap-5 p-3 rounded-xl bg-white shadow-sm">
      {/* Equipment Title */}
      <div>
        <p className="text-[14px] font-semibold text-mainColor-500 pb-1 border-b border-gray-200 mb-2">
          Equipment Details
        </p>
        <p className="text-sm text-gray-600">{displayItem?.itemName || "-"}</p>
      </div>

      {/* Equipment Info Grid */}
      <div className="grid grid-cols-3 gap-4">
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">ID Number</p>
          <p className="text-sm text-gray-600">{displayItem?.idNumber || "-"}</p>
        </div>
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">Unit</p>
          <p className="text-sm text-gray-600">{displayItem?.unit || "-"}</p>
        </div>
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">Type</p>
          <p className="text-sm text-gray-600">{displayItem?.type || "-"}</p>
        </div>
         <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">Capacity</p>
          <p className="text-sm text-gray-600">{displayItem?.capacity || "-"}</p>
        </div>
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">Location</p>
          <p className="text-sm text-gray-600">{displayItem?.location || "-"}</p>
        </div>
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">QR Code</p>
          <p className="text-sm text-gray-600">{displayItem?.qrCode || "-"}</p>
        </div>
      </div>

      {/* Attachments */}
      {filePathList.length > 0 && (
        <div className="border-t pt-3">
          <p className="text-[13px] font-medium text-mainColor-400 mb-2">Attachments</p>
          <div className="overflow-y-auto max-h-32 p-2 border rounded-lg bg-gray-50">
            <div className="w-full flex gap-3 flex-wrap">
              {filePathList.map((imgs, idx) => (
                <FilesView fileView={imgs} key={idx} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewEquipmentEqu;
